<template>
  <div class="order-dispatch">
    <car-cover
      @changeTab="selectTab = 1"
      v-if="selectTab === 2"
      @ceSuan="openCeSuan"
    ></car-cover>
    <find-car
      @changeTab="selectTab = 2"
      v-if="selectTab === 1"
      @ceSuan="openCeSuan"
    ></find-car>
    <navigationCalculation ref="navigationCalculation"></navigationCalculation>
  </div>
</template>

<script>
import carCover from "./components/carCover.vue";
import findCar from "./components/findCar.vue";
import navigationCalculation from "./navigationCalculation.vue";
export default {
  name: "OrderManagement",
  components: {
    carCover,
    findCar,
    navigationCalculation,
  },
  data() {
    return {
      selectTab: 1,
    };
  },
  created() {},
  mounted() {},
  methods: {
    openCeSuan(item) {
      this.$refs.navigationCalculation.init(item);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-dispatch {
  height: 100%;
}
</style>
